<template>
  <div id="cards" :class="src ? 'srcvisible' : ''" style="position: relative ">

    <!-- <v-sheet id="filter" class="ma-5" variant="flat" v-if="luresCached"
    style="position: fixed; padding-top:3em "
    >
            <v-text-field v-model="filter" label="filtro" placeholder="nome uccello" type="text" clearable
                persistent-clear hide-details></v-text-field>

    </v-sheet> -->

    <v-card id="listcard" class="ma-5">
      <v-card-text v-if="luresCached">
        <v-sheet id="lures-sheet" class="">
          <p>
            <v-text-field v-model="filter" label="filtra" placeholder="nome" type="text" clearable persistent-clear
                hide-details></v-text-field>
          </p>

          <v-list color="primary" :border="2" density='comfortable'>
            <template v-for="(lure, i) in lures" :key="i">
              <template v-if="lure.cached">
                <v-list-item :value="lure" @click="toggleLure(lure)" color="primary" :border="false" class="pa-5">
                  <template v-slot:prepend>
                    <v-icon icon="mdi-music"></v-icon>
                  </template>

                  <v-list-item-title class="lure_title">
                    {{ title(lure.url) }}
                    <v-icon>mdi-song</v-icon>
                  </v-list-item-title>
                </v-list-item>
              </template>
              <!-- <template v-else>
                <v-list-item disabled color="secondary" :border="false" class="pa-5">
                  <template v-slot:prepend>
                    <v-icon icon="mdi-volume-off"></v-icon>
                  </template>

                  <v-list-item-title class="lure_title">
                    {{ lure.title }}
                    <v-icon>mdi-song</v-icon>
                  </v-list-item-title>
                </v-list-item>
              </template> -->

            </template>
          </v-list>
        </v-sheet>


      </v-card-text>
      <v-card-text v-else>
        <v-sheet>
          Per usare questa funzione è necessario scaricare il pacchetto dei richiami.<br>
          <v-btn to="/offline_packages/" prepend-icon="mdi-download" class="my-2" color="primary">richiami</v-btn>

        </v-sheet>
      </v-card-text>
    </v-card>

    <v-slide-y-reverse-transition>
      <v-card id="playercard" v-if="src" class="ma-5" theme="dark">

        <v-card-title class="text-center lure_title">
          {{ title(src) }}
        </v-card-title>
        <v-card-text>

          <v-sheet class="d-flex justify-center">
            <!-- {{ src }} <br> -->
            <audio id="lure_audio" controls :src="src">
              Your browser does not support the audio tag.
            </audio>
          </v-sheet>

        </v-card-text>
      </v-card>
    </v-slide-y-reverse-transition>
  </div>
</template>

<script setup>

import { ref, computed, onMounted } from "vue";

import { usePacksStore } from "@/store/packs.js";
const packsStore = usePacksStore();

import { useRuntimeStore } from "@/store/runtime"

const runtimeStore = useRuntimeStore();


import { useApi } from "@/service/api"
const api = useApi()

// const luresBaseURL = window.location.origin + "/lures/"


const audio = ref(null)

const filter = ref(null)


const src = ref(null)

const source = ref(null)


// const fileurl = computed(() => {
//   if (src.value) {
//     return src.value
//   }
//   return null
// })


const title = (url) => {
  const cleaned_url = url.
    replace("http://127.0.0.1:8080/", "").
    replace("files/", "").
    replace("lures/", "").
    replace("/", "").
    replaceAll("_", " ").toLowerCase().split(".")[0]
  return cleaned_url
}

const toggleLure = (lure) => {
  if (src.value == lure.url) {
    src.value = null
    return false
  }

  // into #lure_audio
  src.value = lure.url;

  setTimeout(() => {
    audio.value = document.getElementById("lure_audio");
    audio.value.play();
  }, 50)
}


const luresCached = ref(false)

const luresFromWebServer = ref([])

const lures_pack = packsStore.getPack("lures")

const lures = computed(() => {


  let lures = []

  if (runtimeStore.session.settings.packsDownloadLocation === 'cache') {
    source.value = lures_pack.files
  }

  if (runtimeStore.session.settings.packsDownloadLocation === 'filesystem') {
    source.value = luresFromWebServer.value.files
  }


  if (!filter.value) {
    return source.value
  }

  lures = source.value.filter((lure) => {
    return title(lure.url.toLowerCase()).includes(filter.value.toLowerCase())
  })

  // ? packsStore.getPack("lures")
  // : packsStore.cacheFilePack("lures")

  return lures
})

// watch(lures, async () => {
//   console.log(lures.value)
//   luresCached.value = await packsStore.isPackCached(lures.value)
// })



onMounted(async () => {

  if (runtimeStore.session.settings.packsDownloadLocation === 'cache') {
    await packsStore.checkFilePacksTree()
    luresCached.value = await packsStore.isPackCached(lures_pack)
  }

  if (runtimeStore.session.settings.packsDownloadLocation === 'filesystem') {
    luresFromWebServer.value = await searchWebServerForLures()

    if (luresFromWebServer.value.files.length > 0)
      luresCached.value = true
  }


})






const searchWebServerForLures = async () => {

  console.log("🌍 🔍 searchWebServerForLures")


  const foundLuresAsPack = {
    id: "lures",
    files: []
  }

  const folder_content = await api.local.list("/lures/")

  console.log(folder_content)


  if (folder_content.data !== null) {

    for (const entry of folder_content.data) {

      console.log(entry.name)

      // if (["..", "."].includes(entry.name)) continue
      if (entry.name.at(0) == ".") continue
      if (entry.directory) continue
      if (entry.name.toLowerCase().includes("icon")) continue


      let url = `${api.localWebServerURL}/lures/${entry.name}`

      foundLuresAsPack.files.push({
        url: url,
        cached: true
      })

    }
  }


  if (ENVIRONMENT === 'development') {
    foundLuresAsPack.files = [
      {
        "url": "http://127.0.0.1:8080/lures/allocco_comune.mp3",
        "cached": true
      },
      {
        "url": "http://127.0.0.1:8080/lures/allodola_comune.mp3",
        "cached": true
      },
      {
        "url": "http://127.0.0.1:8080/lures/aquila_reale.mp3",
        "cached": true
      },
      {
        "url": "http://127.0.0.1:8080/lures/astore.mp3",
        "cached": true
      },
    ]
  }


  console.log("foundLuresAsPack")
  console.log(foundLuresAsPack)

  return foundLuresAsPack

}



</script>
<style scoped>
.lure_title {
  font-size: 1.2rem;
  text-transform: capitalize;
}

#cards {
  width: 100%;
  position: relative
}


#filter {
  width: 100%;
  justify-content: center;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 10;
  margin: 0 !important;
}

.srcvisible #playercard {
  width: 100%;
  justify-content: center;
  align-items: center;
  position: sticky;
  bottom: 0;
  z-index: 10;
  margin: 0 !important;
}
</style>
